import React, { useState } from "react";
import './CampaignDetail.css'
import { useSelector } from "react-redux";
import { Search } from "@mui/icons-material";

const CampaignDetail = () => {
  const [locationFilter, setlocationFilter] = useState("ByCountry");
  const [adTypeFilter, setadTypeFilter] = useState("AllAds");
  const campaignDetailData = useSelector((state) => state.campaignDetail.data.data);
  const campaignDetailpending = useSelector(
    (state) => state.campaignDetail.pending
  );
  const campaignDetailerror = useSelector(
    (state) => state.campaignDetail.error
  );

  // console.log(campaignDetailData);
  // console.log(adTypeFilter)
  // console.log(locationFilter)
  // console.log(campaignDetailData?.[`demographic_impressions`][adTypeFilter][locationFilter])
  const filteredData = campaignDetailData?.[`demographic_impressions`]?.[adTypeFilter]?.[locationFilter];
  return (
    <div className="campaignDetail">
      <div className="campaignDetailWrapper">
        <div className="campaignDetailHeading">
          <h3>Campaign Detail</h3> <br/>
          
        </div>
        <div className="campaignDetailFiltersWrapper">
            {/* <div><Search/><input type="text" /></div> */}
          <label>Filter by Location:</label>
          <select
            value={locationFilter}
            onChange={(e) => setlocationFilter(e.target.value)}
          >
            
            <option value="ByCountry">By Country</option>
            <option value="ByCity">By City</option>
            <option value="ByRegion">By Region</option>
            {/* Options for locations */}
          </select>

          <label>Filter by Ad Type:</label>
          <select
            value={adTypeFilter}
            onChange={(e) => setadTypeFilter(e.target.value)}
          >
            <option value="AllAds">All Ads</option>
            <option value="BannerAds">BannerAds</option>
            <option value="FooterAds">FooterAds</option>
            <option value="InterstitialAds">Interstitial Ads</option>
            {/* Options for ad types */}
          </select>
        </div>

        <div className="campaignIdWrapper">
        <h5>Campaign id : {campaignDetailData?.campaign_id}</h5>
        </div>
        <div className="campaignDetailTableWrapper">
        <table className="campaignDetailTable">
        <thead>
          <tr>
            <th>Location</th>
            <th>Ad Type</th>
            <th>Impressions</th>
            <th>Clicks</th>
          </tr>
        </thead>
        <tbody>
          {filteredData?.map((item) => (
            <tr key={item.type}>
              <td>{item.type}</td>
              <td>{adTypeFilter}</td>
              <td>{item.value} Impressions</td>
              {/* Fetch corresponding click data */}
              <td>{campaignDetailData?.['demographic_clicks']?.[adTypeFilter]?.[locationFilter]?.find((clickItem) => clickItem.type === item.type)?.value || 0} Clicks</td>
            </tr>
          ))}
        </tbody>
      </table>
        </div>

      </div>
    </div>
  );
};

export default CampaignDetail;
